import { render } from "./ComponentFlexItem.vue?vue&type=template&id=4759ee32&ts=true"
import script from "./ComponentFlexItem.vue?vue&type=script&lang=ts"
export * from "./ComponentFlexItem.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__